export default __webpack_public_path__ + "static/brandmark-slow-spin-azul-430f15f51d7741e6bb1919c3a2450814.gif";